<template>
  <div>
    <v-layout row wrap class="layout-profile">
      <UserView/>
      <CardInfo/>
    </v-layout>
    <v-layout class="layout-devices">
      <UserDevices/>
    </v-layout>
    <v-dialog v-model="showModal" max-width="500">
      <v-card class="text-xs-center">
        <v-card-title class="subheading justify-center">{{message}}</v-card-title>
        <v-btn color="purple" dark @click="closeModal">ok</v-btn>
      </v-card>
    </v-dialog>
    <!-- <UploadFile/> -->
  </div>
</template>
<script>
import UserView from "@/components/UserView";
import CardInfo from "@/components/CardInfo";
import UserDevices from "@/components/UserDevices";

export default {
  components: {
    UserView,
    CardInfo,
    UserDevices
  },

  mounted() {
    this.showModal = !!this.$route.params.status;
  },

  data: () => ({
    showModal: false,
    message: 'payment was done'
  }),

  computed: {
    status() {
      return !!this.$route.params.status;
    }
  },

  methods: {
    closeModal() {
      this.$router.push("/profile");
      this.showModal = false;
    }
  },

  watch: {
    showModal(value) {
      if (!value) {
        this.$router.push("/profile");
      }
    },

    status() {
      this.$router.push("/profile");
    }
  }
};
</script>
<style scoped lang="scss">
.layout-profile {
  min-height: 350px;
}

.layout-devices {
  margin-top: 20px;
}
</style>